import LayoutContainer from './layout-container';

const components = [
  LayoutContainer
]

const install = function(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
}

export default { install }
